import cn from "@/utils/cn"
import { ComponentProps } from "react"
import { Link as ReactLink } from "react-router"

type LinkProps = {
  type?: "link" | "button"
  className?: string
} & ComponentProps<typeof ReactLink>

const Link = ({
  type = "link",
  className,
  children,
  ...otherProps
}: LinkProps) => (
  <ReactLink
    className={cn(
      "text-primary/90",
      type === "link"
        ? "hover:underline"
        : "flex select-none justify-center rounded-md border border-gray-200 bg-white px-3 py-1.5 text-sm font-semibold leading-6 shadow-xs hover:bg-gray-200 focus-visible:outline-solid focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-100 disabled:cursor-not-allowed disabled:bg-gray-50 disabled:opacity-50",
      className
    )}
    {...otherProps}
  >
    {children}
  </ReactLink>
)

export default Link
